import { render, staticRenderFns } from "./HowToStepsPage.vue?vue&type=template&id=e97476d0"
import script from "./HowToStepsPage.vue?vue&type=script&lang=js"
export * from "./HowToStepsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports